import Vue from "vue/dist/vue.esm";
import BootstrapVue from "bootstrap-vue";

Vue.use(BootstrapVue);



document.addEventListener("DOMContentLoaded", () => {
    const app = new Vue({
        el: "#meet_team",
        data: {
            message: "Hello World",
            activeMenu: "Amanda"
        }
    })
})